module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('z-basePage', {
    attrs: {
      "title": '文件浏览'
    }
  }, [_c('div', {
    staticClass: "search-top"
  }, [_c('span', [_vm._v("文件类型")]), _vm._v(" "), _c('el-select', {
    staticClass: "top-choose",
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.search.type),
      callback: function($$v) {
        _vm.$set(_vm.search, "type", $$v)
      },
      expression: "search.type"
    }
  }, _vm._l((_vm.taskTpl), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.tpl_name
      }
    })
  })), _vm._v(" "), _c('span', [_vm._v("名称/编号")]), _vm._v(" "), _c('el-input', {
    staticClass: "top-choose",
    attrs: {
      "placeholder": "输入名称或编号"
    },
    model: {
      value: (_vm.search.text),
      callback: function($$v) {
        _vm.$set(_vm.search, "text", $$v)
      },
      expression: "search.text"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "back-btn blue shift",
    on: {
      "click": function($event) {
        _vm.searchDoc(1)
      }
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('div', {
    staticClass: "back-list"
  }, [_c('div', {
    staticClass: "list-head"
  }, [_c('div', [_vm._v("文件编号")]), _vm._v(" "), _c('div', [_vm._v("文件类型")]), _vm._v(" "), _c('div', [_vm._v("发布时间")]), _vm._v(" "), _c('div', [_vm._v("创建者")]), _vm._v(" "), _c('div', [_vm._v("文件名称")]), _vm._v(" "), _c('div', [_vm._v("操作")])]), _vm._v(" "), _c('z-scrollDiv', {
    staticClass: "main"
  }, [_vm._l((_vm.dataList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "list-item"
    }, [_c('div', [_vm._v(_vm._s(item.code))]), _vm._v(" "), _c('div', {
      staticClass: "overhide",
      attrs: {
        "title": item.tpl_name
      }
    }, [_vm._v(_vm._s(item.tpl_name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('div', {
      staticClass: "overhide",
      attrs: {
        "title": item.real_name
      }
    }, [_vm._v(_vm._s(item.real_name))]), _vm._v(" "), _c('div', {
      staticClass: "overhide",
      attrs: {
        "title": item.doc_name
      }
    }, [_vm._v(_vm._s(item.doc_name))]), _vm._v(" "), _c('div', [_c('a', {
      on: {
        "click": function($event) {
          _vm.downloadFile(item.id)
        }
      }
    })])])
  }), _vm._v(" "), _c('z-noData', {
    attrs: {
      "list": _vm.dataList
    }
  })], 2)], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.data.current_page,
      "total": _vm.data.total,
      "page-size": _vm.data.per_page,
      "layout": "prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.searchDoc,
      "update:currentPage": function($event) {
        _vm.$set(_vm.data, "current_page", $event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-e032b7d4!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/backEndStage/document/page-skim.vue
// module id = 788
// module chunks = 1